import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { AutomationExecutionEntity } from './automation-execution.entity';
import { AutomationVersionEntity } from './automation-version.entity';
import { BaseEntity } from './base.entity';

@Entity('_automation_trigger')
export class AutomationTriggerEntity extends BaseEntity {
	@Column({ name: '_name', type: 'varchar', length: 255 })
	public name!: string;

	@Column({ name: '_description', type: 'text', nullable: true })
	public description?: string;

	@Column({
		name: '_trigger_type',
		type: 'enum',
		enum: ['event', 'scheduled', 'api', 'manual'],
	})
	public triggerType!: 'event' | 'scheduled' | 'api' | 'manual';

	@Column({ name: '_trigger_config', type: 'json' })
	public triggerConfig!: Record<string, any>;

	@Column({
		name: '_fk__automation_version__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public versionId?: number;

	@Column({ name: '_is_active', type: 'boolean', default: true })
	public isActive!: boolean;

	@Column({ name: '_next_run_at', type: 'timestamp', nullable: true })
	public nextRunAt?: Date;

	// Queue ownership for isolation between systems
	@Column({ name: '_queue_name', type: 'varchar', length: 255, nullable: true })
	public queueName?: string;

	@ManyToOne(() => AutomationVersionEntity)
	@JoinColumn({ name: '_fk__automation_version__id' })
	public version?: AutomationVersionEntity;

	@OneToMany(() => AutomationExecutionEntity, (execution) => execution.trigger)
	public executions!: AutomationExecutionEntity[];

	@Index('idx_automation_trigger_version')
	public static versionIndex: [string] = ['versionId'];

	@Index('idx_automation_trigger_type')
	public static typeIndex: [string] = ['triggerType'];

	@Index('idx_automation_trigger_active')
	public static activeIndex: [string] = ['isActive'];

	@Index('idx_automation_trigger_scheduled')
	public static scheduledIndex: [string, string, string, string] = [
		'triggerType',
		'isActive',
		'nextRunAt',
		'queueName',
	];

	// Getter for compatibility
	public get config(): Record<string, any> {
		return this.triggerConfig;
	}
}
